import RadioGroup from "@p-ban/common/src/components/form/radio/RadioGroup"

import useMinAndStandardLabelQuery from "../../../../../../../api/estimate/useMinAndStandardLabelQuery"
import ESTIMATE_CONSTANT from "../../../../../constant/estimateConstant"
import FIELD_NAMES from "../../../../../constant/fieldNames"
import getDisplayCondition from "../../../../../service/getDisplayCondition"
import type { OneClickFieldProps } from "../../../../../types"
import MinAndStandardLabelProvider from "../../../../components/1Click/MinAndStandardLabel/MinAndStandardLabelProvider"
import Radio from "../../../../components/1Click/MinAndStandardLabel/MinAndStandardLabelRadio"
import OneClickField from "../../../../components/1Click/form/OneClickField"
import OneClickFieldMessages from "../../../../components/1Click/form/OneClickFieldMessages"
import OneClickFieldStack from "../../../../components/1Click/form/OneClickFieldStack"
import HELP_LINKS from "../../../../constant/helpLinks"
import isValidMinLand from "../../../../service/visibleValidator/isValidMinLand"

import img from "./minLand.png"

const 最小ビア径 = ({ values, handlers, errors }: OneClickFieldProps) => {
  const { minLand: shouldShow } = getDisplayCondition(values)

  const { minId, standardId } = useMinAndStandardLabelQuery("minLand", values)

  return (
    <OneClickField
      isShow={shouldShow}
      legend={"最小ビア径／\nランド径"}
      helpURL={HELP_LINKS["最小ビア径／ランド径"]}
      src={img}
    >
      <MinAndStandardLabelProvider minId={minId} standardId={standardId}>
        <RadioGroup
          name={FIELD_NAMES["最小ビア径／ランド径"]}
          selectedValue={values.minLand}
          onChange={handlers.radio}
          shouldRender={(value) => isValidMinLand(values, value)}
        >
          <OneClickFieldStack>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.35mm"].value}>φ0.15/0.35mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.4mm"].value}>φ0.15/0.4mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.45mm"].value}>φ0.2/0.45mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.5mm(リジッド)"].value}>φ0.2/0.5mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.25/0.5mm(リジッド)"].value}>φ0.25/0.5mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.5mm"].value}>φ0.3/0.5mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(リジッド)"].value}>φ0.3/0.6mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.4/0.8mm"].value}>φ0.4/0.8mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.0mm"].value}>φ0.5/1.0mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.3mm"].value}>φ0.5/1.3mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.5/1.5mm"].value}>φ0.5/1.5mm</Radio>

            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(フレキシブル)"].value}>
              φ0.3/0.6mm
            </Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.25/0.5mm(フレキシブル)"].value}>
              φ0.25/0.5mm
            </Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.2/0.5mm(フレキシブル)"].value}>
              φ0.2/0.5mm
            </Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.15/0.3mm"].value}>φ0.15/0.3mm</Radio>
            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.12/0.27mm"].value}>φ0.12/0.27mm</Radio>

            <Radio value={ESTIMATE_CONSTANT["最小ビア径／ランド径"]["φ0.3/0.6mm(メタル)"].value}>φ0.3/0.6mm</Radio>
          </OneClickFieldStack>
        </RadioGroup>
      </MinAndStandardLabelProvider>
      <OneClickFieldMessages error={errors?.minLand} />
    </OneClickField>
  )
}

export default 最小ビア径
